export default "__VITE_PUBLIC_ASSET__63a3adc8__"